import {domLoader} from "@/loader.js";
import {debug} from "@/debug.js";

window.hoverLoaded = false

// افکت تیلت فقط از این عرض به بالا اجرا می‌شود (همان شرطی که در
// هندلرهای mousemove/mouseleave بود).
const CARD_3D_MIN_WIDTH = 769;


domLoader(function () {

  debug.log("hover entered")
  if (window.hoverLoaded) return
  window.hoverLoaded = true

  debug.log("hover loaded")


  let windowWidth = window.innerWidth;

  // المان‌هایی که هنوز will-change نگرفته‌اند، تا اگر کاربر پنجره را به
  // اندازهٔ دسکتاپ رساند دقیقا مثل قبل promote شوند.
  const pendingPromotion = new Set();

  function promote(el) {
    el.style.willChange = "transform";
    pendingPromotion.delete(el);
  }

  function promoteAllPending() {
    pendingPromotion.forEach(promote);
  }

  window.addEventListener('resize', function () {
    windowWidth = window.innerWidth;
    if (windowWidth >= CARD_3D_MIN_WIDTH) {
      promoteAllPending();
    }
  })



  window.Card3DInit = function () {
    document.querySelectorAll("[data-limaster-3d]").forEach((el) => {

      if (el.dataset.card3dInit === "1") return;
      el.dataset.card3dInit = "1";

      const scale = parseFloat(el.dataset.scale || "1.05");

      el.style.transition = "transform 0.1s ease";
      // preserve-3d نگه داشته می‌شود: هم stacking context و هم containing
      // block فرزندان absolute (تایمر تخفیف، اورلی آنلاین و ...) از آن
      // می‌آید، پس ترتیب رسم و موقعیت‌ها عوض نمی‌شود.
      el.style.transformStyle = "preserve-3d";

      // will-change: transform مرورگر را وادار می‌کند برای هر المان یک
      // لایهٔ GPU دائمی بسازد. روی موبایل افکت اصلا اجرا نمی‌شود (شرط
      // پایین)، ولی هزینهٔ لایه‌ها پرداخت می‌شد — روی صفحهٔ محصول ده‌ها
      // اسلاید گالری و کارت پیشنهادی. حالا فقط در حالت دسکتاپ ست می‌شود.
      if (windowWidth >= CARD_3D_MIN_WIDTH) {
        promote(el);
      } else {
        pendingPromotion.add(el);
      }

      el.addEventListener("mousemove", (e) => {
        if(windowWidth < CARD_3D_MIN_WIDTH){
          return
        }
        const rect = el.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        const rotateX = -((y - centerY) / centerY) * 10;
        const rotateY = ((x - centerX) / centerX) * 10;

        el.style.transform = `perspective(500px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
      });

      el.addEventListener("mouseleave", () => {
        if(windowWidth < CARD_3D_MIN_WIDTH){
          return
        }
        el.style.transform = "perspective(500px) rotateX(0deg) rotateY(0deg) scale(1)";
      });
    });
  };
  if (typeof Card3DInit === 'function') {
    Card3DInit();
  }
});
